<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="客户信息：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="是否认证：">
            <el-select v-model="query.certificationStatus" placeholder="请选择认证状态" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="已认证" :value="1"></el-option>
              <el-option label="未认证" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户状态：">
            <el-select v-model="query.customerStatus" placeholder="请选择客户状态" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="已激活" :value="1"></el-option>
              <el-option label="未激活" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意向度：">
            <el-select v-model="query.intentionality" placeholder="请选择意向度" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="高" :value="1"></el-option>
              <el-option label="中" :value="2"></el-option>
              <el-option label="低" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="加入时间" :value="1"></el-option>
              <!-- <el-option label="下次跟进时间" :value="2"></el-option> -->
              <el-option label="修改时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-upload style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList" v-hasPermi="['clue:publicClue:import']">
            <el-button size="mini" type="primary" plain>导入</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['clue:publicClue:export']">导出</el-button>
          <el-button type="primary" size="mini" @click="handleTemplate" plain>下载模板</el-button>
          <el-button type="primary" size="mini" @click="handleUpdate('',5)" v-hasPermi="['clue:publicClue:allocation']">批量分配</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['clue:publicClue:add']">添加线索</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" height="500">
        <el-table-column type="selection" width="50" />
        <el-table-column label="客户信息" prop="" align="center" fixed width="160">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{row.customerName}}</el-link><br />
              <el-link type="primary">{{row.customerPhone}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户状态" prop="" align="center">
          <template slot-scope="{row}">
            {{row.customerStatus?'已激活':'未激活'}}
          </template>
        </el-table-column>
        <el-table-column label="是否认证" prop="" align="center">
          <template slot-scope="{row}">
            {{row.certificationStatus==1?'已认证':'未认证'}}
          </template>
        </el-table-column>
        <el-table-column label="意向度" prop="" align="center">
          <template slot-scope="{row}">
            {{row.intentionality==1?'高':row.intentionality==2?'中':row.intentionality==3?'低':''}}
          </template>
        </el-table-column>
        <el-table-column label="加入时间" prop="createdTime" align="center" sortable width="160">
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" align="center" sortable width="160">
        </el-table-column>
        <el-table-column label="操作人" prop="operatingStaff" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="handleUpdate(row,0)" v-if="!row.customer.mainId && row.subCount && row.customerUserPO.firstLoginTime">查看子账户</el-button> -->
            <el-button type="text" @click="handleUpdate(row,1)" v-hasPermi="['clue:publicClue:edit']">编辑</el-button>
            <el-button type="text" @click="handleUpdate(row,3)" v-hasPermi="['clue:publicClue:label']">打标签</el-button>
            <el-button type="text" @click="handleUpdate(row,2)" v-hasPermi="['clue:publicClue:allocation']">分配</el-button>
            <el-button type="text" @click="handleUpdate(row,4)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <banner-add ref="bannerAdd" :standingList="standingList" :discountList="discountList" :configList="configList" :labelList="labelList" :addressList="addressList" :popType="popType" @created="doQueryList({})" />

    <!-- 打标签 -->
    <label-add ref="labelAdd" @created="doQueryList({})" :labelList="labelList" />
  </div>
</template>

<script>
import bannerAdd from './add'
import bannerEdit from './edit'
import labelAdd from './addLabel'
import userApi from '@/api/user'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import sysAddrApi from '@/api/sys/sysAddr'
import clientLabelApi from '@/api/client/label'
import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import clientListApi from '@/api/client/clientList'
// import userApi from '@/api/sys/user'
export default {
  components: {
    Pagination,
    bannerAdd,
    labelAdd,
    bannerEdit
  },
  data() {
    return {
      // level 6:研修班 7:体验班 8:普通用户
      list: [],
      total: 0,
      popType: null,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        cueType: 0
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // multiple: true
      },
      selectItems: [],
      activeName: '1',
      standingList: [],
      discountList: [],
      configList: [],
      labelList: [],
      addressList: [],
      // technicianList: [],
      dateTime: null,
      // businessStanding: [], //业务员身份
    }
  },
  created() {
    // this.getBusinessStanding()
    this.doQueryList({
      pageNo: 1
    })
    this.getConfig()
    this.getStandingList()
    // this.getDiscountList()
    this.getLabelList()
    this.getAddressList()
    // this.getTechnicianList()
    // this.getBusinessList()
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        cueType: 0
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    handleUpdates(row) {
      this.handleUpdate(row, 1)
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({
        pageNo: 1
      })
      // console.log("activeName: ",this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // this.query.isOpenSea=0
      // console.log('this.query: ',this.query,this.dateTime);
      // return
      let query = {
        ...this.query
      }
      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        if (this.query.timeType == 1) {
          query.createdTimeStart = this.dateTime[0]
          query.createdTimeEnd = this.dateTime[1]
        }
        if (this.query.timeType == 2) {
          query.nextFollowUpTimeStart = this.dateTime[0]
          query.nextFollowUpTimeEnd = this.dateTime[1]
        }
        if (this.query.timeType == 3) {
          query.operatedTimeStart = this.dateTime[0]
          query.operatedTimeEnd = this.dateTime[1]
        }
      }
      delete query.timeType
      this.listLoading = true
      return userApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'shopType,dayAVGOutpatients,employeeNums,carryProjects'
      }).then(({
        data
      }) => {
        this.configList = data.list
        // console.log("配置: ",data);
      })
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.standingList = data
        // console.log('客户身份: ',data);
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',this.addressList);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    // 获取标签列表
    getLabelList() {
      clientLabelApi.fetchList({
        pageNo: 1,
        pageSize: 999,
        tagStatus: 1
      }).then(({
        data
      }) => {
        this.labelList = data.list.map(i => {
          return {
            id: i.customerTagGroup.id,
            name: i.customerTagGroup.groupName,
            children: i.customerTagList
          }
        })
      })
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.popType = 0
      this.$refs.bannerAdd.handleUpdate({
        row: {},
        command: 0
      })
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.clientShow.handleShow(row.customerCertificates)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      this.popType = type
      if ([5].includes(type)) {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择客户')
          return
        }
        // console.log('command: ', command, this.selectItems);
        let ids = this.selectItems.map(row => row.id)
        let txt = ""
      }
      // if (type == 2) {
      //   this.$refs.bannerEdit.handleUpdate({
      //     row,
      //     command: type
      //   })
      // }
      if ([1, 2, 5].includes(type)) {
        this.$refs.bannerAdd.handleUpdate({
          row: type == 5 ? this.selectItems : row,
          command: type
        })
      }
      if (type == 3) {
        this.$refs.labelAdd.handleUpdate(row)
      }
      if (type == 4) {
        this.$router.push("/log/log?type=45&id=" + row.id);
      }
      // if(type==3){
      //   this.$refs.labelAdd.handleUpdate(row)
      // }
      // if(!type){
      //   this.$refs.subaccount.handleShow(row)
      // }
    },
    handleDownload() {
      this.$router.push("/export/list?code=EEForMyClue&cueType=0")
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      userApi.clueImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleTemplate() {
      userApi.template1()
    }
  }
}
</script>
